__turbopack_context__.v({
  "dropdown": "Nav-module-scss-module__XvYc_q__dropdown",
  "dropdownContent": "Nav-module-scss-module__XvYc_q__dropdownContent",
  "dropdownMenu__action": "Nav-module-scss-module__XvYc_q__dropdownMenu__action",
  "dropdownMenu__item": "Nav-module-scss-module__XvYc_q__dropdownMenu__item",
  "nav": "Nav-module-scss-module__XvYc_q__nav",
  "nav__action": "Nav-module-scss-module__XvYc_q__nav__action",
  "nav__action_active": "Nav-module-scss-module__XvYc_q__nav__action_active",
  "nav__item": "Nav-module-scss-module__XvYc_q__nav__item",
});
